module.exports = __webpack_public_path__ + "static/media/FiraSans-Regular.895f5b02.ttf";